/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2023, Zumper
 */

import { traverseParentsForSelectors } from './traverseParentsForSelectors'

export const getInteractionTarget = (entries: PerformanceEventTiming[]) => {
  const targets: string[] = []
  entries.forEach((entry) => {
    if (entry.target) {
      targets.push(traverseParentsForSelectors(entry.target as HTMLElement, ''))
    }
  })
  return String(targets)
}
